import axios from 'axios';
import { Message } from 'element-ui';
import { getToken, getUserName } from './auth';
import { KEY_ADMIN_USER_TOKEN } from './constants';

function padStart(value) {
    return value.toString().padStart(2, '0');
}


export function CurrentDate() {
    const now = new Date();
    const year = now.getFullYear();
    const month = padStart(now.getMonth() + 1);
    const day = padStart(now.getDate());
    // console.log(`${year}-${month}-${day}`)
    return `${year}-${month}-${day}`;
}


export const service = axios.create({
    baseURL: '/api',
    timeout: 3000,
    // 
})


// 请求拦截器
service.interceptors.request.use(
    (config) => {
        //设置token
        config.headers['admin-token'] = getToken(KEY_ADMIN_USER_TOKEN);
        config.headers['admin-name'] = getUserName()
        config.headers['Content-Type'] = 'multipart/form-data';
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)


// 响应拦截器
service.interceptors.response.use(
    (response) => {
        //设置token
        let { status } = response
        if (status !== 200) {
            Message({ message: response.data || 'error', type: 'warning' })
        }
        return response
    },
    (error) => {
        return Promise.reject(error)
    }
)

export function thz_rest_api(url, data, method = 'get', root) {
    return new Promise((resolve, reject) => {
        root.service[method](url, data)
            .then(res => {
                // root.message({ message: res.data.msg, type: 'success' })
                resolve(res.data)
            })
            .catch(err => {
                reject(err.data)
            })
    })
}


export function get_system_config() {
    return service({
        method: 'get',
        url: '/config/list'
    })
}

export function update_system_config(data) {
    return service({
        method: 'patch',
        url: '/config/update',
        data
    })
}